import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 90vh;
  min-height: 60vh;
  overflow: hidden;
  outline: none; /* Remove outline padrão */
  
  /* Garante que o container possa receber foco quando necessário */
  &:focus-visible {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0; /* Permite que o flex child encolha */
`;

export const ScrollableContent = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  
  /* Custom scrollbar para melhor UX */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
    
    &:hover {
      background: #a1a1a1;
    }
  }
`;

export const LoadingMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  font-size: 1rem;
  color: #666;
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 4px;
  color: #c33;
  font-size: 0.875rem;
`;

export const HtmlContent = styled.div`
  flex: 1;
  width: 100%;
  outline: none;
  margin: 16px;
  min-height: 0; /* Permite que o flex child encolha */
  
  iframe {
    width: 100%;
    height: 100%;
    min-height: 300px;
    border: 1px solid #ddd;
    border-radius: 8px;
  }
  
  /* Garantir que elementos focáveis dentro do HTML sejam acessíveis */
  & * {
    &:focus-visible {
      outline: 2px solid #0066cc;
      outline-offset: 1px;
    }
  }
  
  /* Estilos para o conteúdo HTML da nota de repasse */
  & table {
    width: 100%;
    border-collapse: collapse;
  }
  
  & th,
  & td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  & th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  
  & p {
    margin: 8px 0;
  }
  
  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    margin: 16px 0 8px 0;
  }
  
  /* Garantir que inputs, buttons e links sejam acessíveis */
  & input,
  & button,
  & a,
  & select,
  & textarea {
    &:focus {
      outline: 2px solid #0066cc;
      outline-offset: 1px;
    }
  }
`;

export const DownloadSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
  flex-shrink: 0; /* Impede que a seção seja comprimida */
  
  /* Responsividade para telas pequenas */
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.5rem;
    padding: 12px;
    
    button {
      width: 100%;
      max-width: 200px;
    }
  }
`;

export const EmailModalContent = styled.div`
  padding: 24px;
  
  h3 {
    margin: 0 0 24px 0;
    color: #333;
    font-size: 1.25rem;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #007acc;
    box-shadow: 0 0 0 2px rgba(0, 122, 204, 0.2);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  min-height: 80px;
  
  &:focus {
    outline: none;
    border-color: #007acc;
    box-shadow: 0 0 0 2px rgba(0, 122, 204, 0.2);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;
